import { type ValueFunction, type ValueOrFunction } from './types.js';

const isFunction = <TValue, TArgument>(
  valueOrFunction: ValueOrFunction<TValue, TArgument>,
): valueOrFunction is ValueFunction<TValue, TArgument> =>
  typeof valueOrFunction === 'function';

export const isValue = <TValue, TArgument>(
  valueOrFunction: ValueOrFunction<TValue, TArgument>,
): valueOrFunction is TValue => typeof valueOrFunction !== 'function';

export const resolveValueOrFunction = <TValue, TArgument>(
  valueOrFunction: ValueOrFunction<TValue, TArgument>,
  argument: TArgument,
): TValue =>
  isFunction(valueOrFunction) ? valueOrFunction(argument) : valueOrFunction;
